import { StudentCVsView } from "../Views";
import { useParams } from "react-router-dom";
import { getUserId, useGetCompanyId } from "../../utils/utilFunctions";

export const StudentCVsPage = () => {
	const { companyId } = useParams<{ companyId?: string }>();
	const userCompanyId = useGetCompanyId();

	return <StudentCVsView companyId={companyId ?? userCompanyId} />;
};
